import { render, staticRenderFns } from "./RedeemReward.vue?vue&type=template&id=14054569&scoped=true&"
import script from "./RedeemReward.vue?vue&type=script&lang=js&"
export * from "./RedeemReward.vue?vue&type=script&lang=js&"
import style0 from "./RedeemReward.vue?vue&type=style&index=0&id=14054569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14054569",
  null
  
)

export default component.exports